import type { Messages } from "./en";

export const vi = {
  "app.name": "YourCV",
  "app.tagline": "Một CV đúng là bạn.",

  "nav.signIn": "Đăng nhập",
  "nav.signOut": "Đăng xuất",
  "nav.dashboard": "CV của bạn",
  "nav.templates": "Mẫu",
  "nav.billing": "Thanh toán",
  "nav.organizations": "Tổ chức",
  "nav.settings": "Cài đặt",
  "nav.accountMenu": "Menu tài khoản",

  "common.save": "Lưu",
  "common.saved": "Đã lưu",
  "common.saving": "Đang lưu…",
  "common.saveFailed": "Không lưu được",
  "common.cancel": "Huỷ",
  "common.delete": "Xoá",
  "common.edit": "Sửa",
  "common.copy": "Sao chép",
  "common.copied": "Đã sao chép",
  "common.close": "Đóng",
  "common.add": "Thêm",
  "common.remove": "Bỏ",
  "common.back": "Quay lại",
  "common.done": "Xong",
  "common.loading": "Đang tải…",
  "common.retry": "Thử lại",
  "common.search": "Tìm",
  "common.preview": "Xem trước",
  "common.print": "In",
  "common.share": "Chia sẻ",
  "common.upgrade": "Nâng cấp",
  "common.free": "Miễn phí",
  "common.pro": "Pro",
  "common.month": "Hàng tháng",
  "common.year": "Hàng năm",
  "common.savePercent": "Tiết kiệm 20%",
  "common.moreOptions": "Tuỳ chọn khác",
  "common.pickColor": "Chọn màu",
  "common.optional": "Không bắt buộc",
  "common.confirm": "Xác nhận",
  "common.dismiss": "Bỏ qua",
  "common.language": "Ngôn ngữ",
  "theme.label": "Giao diện",
  "theme.switchToLight": "Chuyển sang chế độ sáng",
  "theme.switchToDark": "Chuyển sang chế độ tối",
  "common.english": "English",
  "common.vietnamese": "Tiếng Việt",
  "common.open": "Mở",
  "common.create": "Tạo",
  "common.new": "Mới",
  "common.rename": "Đổi tên",
  "common.duplicate": "Nhân bản",
  "common.working": "Đang xử lý…",
  "common.moveUp": "Di chuyển lên",
  "common.moveDown": "Di chuyển xuống",
  "common.menu": "Menu",
  "common.retrySave": "Thử lại",

  "landing.heroTitle": "Một CV đúng là bạn.",
  "landing.heroSubtitle": "Viết một lần. Chọn mẫu. Chia sẻ liên kết hoặc in.",
  "landing.cta": "Tạo CV của bạn",
  "landing.secondary": "Xem các mẫu",
  "landing.proofTemplates": "Tám mẫu tinh tế, sẵn sàng để in",
  "landing.proofPrivacy": "Riêng tư theo mặc định",
  "landing.proofExport": "Chia sẻ liên kết, nhúng hoặc in",
  "landing.templatesTitle": "Mẫu",
  "landing.viewAll": "Xem tất cả",
  "landing.stepsTitle": "Ba bước",
  "landing.step1": "Thêm câu chuyện của bạn",
  "landing.step2": "Chọn một mẫu",
  "landing.step3": "Chia sẻ hoặc in",
  "landing.pricingTitle": "Giá đơn giản",
  "landing.pricingSubtitle": "Bắt đầu miễn phí. Nâng cấp khi cần.",
  "landing.freePrice": "Miễn phí",
  "landing.proPrice": "8 $ / tháng",
  "landing.freeFeature1": "Hai CV",
  "landing.freeFeature2": "20 MB hình ảnh",
  "landing.freeFeature3": "Năm mẫu",
  "landing.freeFeature4": "Liên kết công khai và in",
  "landing.proFeature1": "Tới 100 CV",
  "landing.proFeature2": "200 MB hình ảnh",
  "landing.proFeature3": "Tất cả tám mẫu",
  "landing.proFeature4": "Không huy hiệu",
  "landing.footerNote": "Dành cho những người quan tâm đến từng chi tiết.",
  "landing.previewName": "Nguyễn Văn A",
  "landing.previewHeadline": "Kỹ sư Frontend cấp cao",

  "auth.welcomeBack": "Chào mừng trở lại.",
  "auth.createAccount": "Tạo tài khoản.",
  "auth.email": "Email",
  "auth.password": "Mật khẩu",
  "auth.name": "Tên",
  "auth.signIn": "Đăng nhập",
  "auth.signUp": "Tạo tài khoản",
  "auth.google": "Tiếp tục với Google",
  "auth.facebook": "Tiếp tục với Facebook",
  "auth.x": "Tiếp tục với X",
  "auth.or": "hoặc",
  "auth.socialError": "Không thể đăng nhập bằng nhà cung cấp này. Vui lòng thử lại.",
  "auth.noAccount": "Mới đến?",
  "auth.haveAccount": "Đã có tài khoản?",
  "auth.forgot": "Quên mật khẩu?",
  "auth.passwordHint": "Dùng 8 ký tự trở lên.",
  "auth.resetTitle": "Đặt lại mật khẩu.",
  "auth.resetSubtitle": "Chúng tôi sẽ gửi liên kết qua email.",
  "auth.sendLink": "Gửi liên kết",
  "auth.resetSent": "Kiểm tra email để lấy liên kết.",
  "auth.newPassword": "Mật khẩu mới",
  "auth.confirmPassword": "Nhập lại mật khẩu",
  "auth.passwordsDiffer": "Mật khẩu không khớp.",
  "auth.resetAction": "Đặt mật khẩu mới",
  "auth.resetDone": "Đã cập nhật mật khẩu. Bạn có thể đăng nhập.",
  "auth.resetInvalid": "Liên kết không hợp lệ hoặc đã hết hạn. Hãy yêu cầu liên kết mới.",
  "auth.invalidEmail": "Nhập email hợp lệ.",
  "auth.passwordShort": "Dùng ít nhất 8 ký tự.",
  "auth.nameRequired": "Nhập tên của bạn.",
  "auth.invalidCredentials": "Email hoặc mật khẩu chưa đúng.",
  "auth.emailTaken": "Email này đã có tài khoản.",
  "auth.tooManyAttempts": "Quá nhiều lần thử. Vui lòng thử lại sau.",
  "auth.genericError": "Không thể hoàn tất. Vui lòng thử lại.",
  "auth.verifyTitle": "Kiểm tra hộp thư.",
  "auth.verifyBody": "Mở liên kết trong email để hoàn tất đăng ký.",
  "auth.backToSignIn": "Quay lại đăng nhập",

  "dashboard.title": "CV của bạn",
  "dashboard.count": "Tổng {count}",
  "dashboard.newCv": "CV mới",
  "dashboard.emptyTitle": "Chưa có CV nào.",
  "dashboard.emptyBody": "Tạo CV đầu tiên trong một phút.",
  "dashboard.edited": "Sửa {when}",
  "dashboard.quota": "{used} trên {limit} CV",
  "dashboard.upgradeTitle": "Nhiều chỗ hơn, mọi mẫu.",
  "dashboard.upgradeBody": "Pro cho bạn 100 CV, 200 MB và không huy hiệu.",
  "dashboard.untitled": "CV chưa đặt tên",
  "dashboard.deleteConfirm": "Xoá CV này? Bạn có thể khôi phục trong 30 ngày.",
  "dashboard.searchPlaceholder": "Tìm CV của bạn",
  "dashboard.justNow": "vừa xong",
  "dashboard.yesterday": "hôm qua",
  "dashboard.daysAgo": "{count} ngày trước",

  "editor.profile": "Hồ sơ",
  "editor.experience": "Kinh nghiệm",
  "editor.education": "Học vấn",
  "editor.projects": "Dự án",
  "editor.skills": "Kỹ năng",
  "editor.languages": "Ngôn ngữ",
  "editor.certifications": "Chứng chỉ",
  "editor.awards": "Giải thưởng",
  "editor.links": "Liên kết",
  "editor.addExperience": "Thêm kinh nghiệm",
  "editor.addEducation": "Thêm học vấn",
  "editor.addProject": "Thêm dự án",
  "editor.addSkill": "Thêm kỹ năng",
  "editor.addLanguage": "Thêm ngôn ngữ",
  "editor.addCertification": "Thêm chứng chỉ",
  "editor.addAward": "Thêm giải thưởng",
  "editor.addLink": "Thêm liên kết",
  "editor.emptyExperience": "Thêm vị trí đầu tiên.",
  "editor.emptyEducation": "Thêm trường đầu tiên.",
  "editor.emptyProjects": "Thêm một dự án bạn tự hào.",
  "editor.emptySkills": "Thêm một kỹ năng.",
  "editor.emptyLanguages": "Thêm một ngôn ngữ.",
  "editor.emptyCertifications": "Thêm một chứng chỉ.",
  "editor.emptyAwards": "Thêm một giải thưởng.",
  "editor.emptyLinks": "Thêm một liên kết.",
  "editor.dragHint": "Kéo để sắp xếp",
  "editor.templateChanged": "Đã đổi mẫu",
  "editor.sectionsTitle": "Phần",
  "editor.hideSection": "Ẩn phần",
  "editor.showSection": "Hiện phần",
  "editor.previewTab": "Xem trước",
  "editor.formTab": "Sửa",
  "editor.unsaved": "Thay đổi chưa lưu",
  "editor.savedAll": "Đã lưu mọi thay đổi",
  "editor.errorSave": "Không lưu được. Đang thử lại…",
  "editor.titlePlaceholder": "Tên CV",

  "profile.fullName": "Họ tên",
  "profile.headline": "Tiêu đề",
  "profile.email": "Email",
  "profile.phone": "Điện thoại",
  "profile.location": "Địa điểm",
  "profile.summary": "Giới thiệu",
  "profile.avatar": "Ảnh",
  "profile.uploadPhoto": "Tải ảnh lên",
  "profile.removePhoto": "Bỏ ảnh",
  "profile.showEmail": "Hiện email trên CV",
  "profile.showPhone": "Hiện điện thoại trên CV",
  "profile.summaryHint": "Hai hoặc ba câu. Bạn làm tốt nhất điều gì?",

  "experience.company": "Công ty",
  "experience.role": "Vị trí",
  "experience.location": "Địa điểm",
  "experience.employmentType": "Loại hình",
  "experience.startDate": "Bắt đầu",
  "experience.endDate": "Kết thúc",
  "experience.current": "Tôi đang làm ở đây",
  "employment.fullTime": "Toàn thời gian",
  "employment.partTime": "Bán thời gian",
  "employment.contract": "Hợp đồng",
  "employment.internship": "Thực tập",
  "employment.freelance": "Tự do",
  "experience.highlights": "Điểm nổi bật",
  "experience.highlightPlaceholder": "Mỗi dòng một kết quả",

  "education.institution": "Trường",
  "education.degree": "Bằng cấp",
  "education.fieldOfStudy": "Ngành",
  "education.location": "Địa điểm",
  "education.startDate": "Bắt đầu",
  "education.endDate": "Kết thúc",
  "education.current": "Tôi đang học ở đây",
  "education.description": "Ghi chú",

  "projects.name": "Dự án",
  "projects.role": "Vai trò của bạn",
  "projects.description": "Mô tả",
  "projects.url": "URL trực tiếp",
  "projects.repoUrl": "Kho mã",
  "projects.startDate": "Bắt đầu",
  "projects.endDate": "Kết thúc",
  "projects.current": "Đang tiếp tục",
  "projects.highlights": "Điểm nổi bật",
  "projects.tech": "Công nghệ",
  "projects.techPlaceholder": "TypeScript, React, Cloudflare",
  "projects.featured": "Làm nổi bật dự án này",
  "projects.image": "Hình ảnh",
  "projects.uploadImage": "Tải ảnh lên",
  "projects.removeImage": "Xóa ảnh",

  "skills.name": "Kỹ năng",
  "skills.category": "Nhóm",
  "skills.level": "Mức",

  "languages.name": "Ngôn ngữ",
  "languages.proficiency": "Trình độ",
  "languages.native": "Bản ngữ",
  "languages.fluent": "Lưu loát",
  "languages.professional": "Chuyên nghiệp",
  "languages.limited": "Cơ bản",

  "certifications.name": "Chứng chỉ",
  "certifications.issuer": "Tổ chức",
  "certifications.issueDate": "Ngày cấp",
  "certifications.expiryDate": "Hết hạn",
  "certifications.credentialId": "Mã chứng chỉ",
  "certifications.credentialUrl": "URL chứng chỉ",

  "awards.title": "Giải thưởng",
  "awards.issuer": "Tổ chức",
  "awards.date": "Ngày",
  "awards.description": "Mô tả",

  "links.type": "Loại",
  "links.label": "Nhãn",
  "links.url": "URL",
  "links.linkedin": "LinkedIn",
  "links.github": "GitHub",
  "links.website": "Trang web",
  "links.portfolio": "Danh mục",
  "links.email": "Email",
  "links.custom": "Tự chọn",

  "templates.title": "Mẫu",
  "templates.all": "Tất cả",
  "templates.use": "Dùng mẫu",
  "templates.previous": "Mẫu trước",
  "templates.next": "Mẫu tiếp",
  "templates.current": "Đang dùng",
  "templates.proRequired": "Mẫu này có trong gói Pro.",
  "templates.upgradeBody": "Mở khoá cả tám mẫu và bỏ huy hiệu.",
  "templates.upgradeCta": "Xem Pro",
  "templates.chooseCv": "Chọn một CV",
  "templates.apply": "Áp dụng",
  "templates.classic.name": "Cổ điển",
  "templates.classic.description": "CV chữ serif với vẻ trang trọng.",
  "templates.minimal.name": "Tối giản",
  "templates.minimal.description": "Khoảng trống, rõ ràng, một điểm nhấn.",
  "templates.mono.name": "Mono",
  "templates.mono.description": "Kỹ thuật và chính xác.",
  "templates.editorial.name": "Tạp chí",
  "templates.editorial.description": "Tên bạn như một tiêu đề tạp chí.",
  "templates.sidebar.name": "Cột bên",
  "templates.sidebar.description": "Bố cục hai cột với cột bên nhẹ nhàng.",
  "templates.timeline.name": "Dòng thời gian",
  "templates.timeline.description": "Một đường rõ ràng qua sự nghiệp.",
  "templates.compact.name": "Gọn",
  "templates.compact.description": "Vừa sự nghiệp dài trên một trang.",
  "templates.bold.name": "Đậm",
  "templates.bold.description": "Tên mạnh và tiêu đề rộng.",

  "share.title": "Chia sẻ",
  "share.linkTab": "Liên kết",
  "share.embedTab": "Nhúng",
  "share.sdkTab": "SDK",
  "share.visibility": "Hiển thị",
  "share.private": "Riêng tư",
  "share.unlisted": "Không niêm yết",
  "share.public": "Công khai",
  "share.privateHint": "Chỉ bạn mở được CV này.",
  "share.unlistedHint": "Ai có liên kết đều mở được.",
  "share.publicHint": "Ai cũng mở được, công cụ tìm kiếm có thể lập chỉ mục.",
  "share.publish": "Xuất bản để chia sẻ",
  "share.unpublish": "Chuyển riêng tư",
  "share.copy": "Sao chép liên kết",
  "share.open": "Mở",
  "share.pasteInto": "Dán vào bất kỳ trang HTML nào.",
  "share.install": "Cài đặt",
  "share.sdkHint": "Tạo mật khẩu ứng dụng trong Cài đặt.",
  "share.appPasswords": "Cài đặt → Mật khẩu ứng dụng",
  "share.published": "Đã xuất bản",
  "share.badgeNote": "CV miễn phí hiện một huy hiệu nhỏ.",

  "settings.title": "Cài đặt",
  "settings.profileTab": "Hồ sơ",
  "settings.securityTab": "Bảo mật",
  "settings.appPasswordsTab": "Mật khẩu ứng dụng",
  "settings.languageTab": "Ngôn ngữ",
  "settings.dangerTab": "Nguy hiểm",
  "settings.displayName": "Tên hiển thị",
  "settings.emailReadonly": "Email",
  "settings.newAppPassword": "Mật khẩu ứng dụng mới",
  "settings.appPasswordName": "Tên",
  "settings.scopes": "Quyền",
  "settings.expiry": "Hết hạn",
  "settings.expiry30": "30 ngày",
  "settings.expiry90": "90 ngày",
  "settings.expiry365": "1 năm",
  "settings.tokenTitle": "Sao chép token ngay",
  "settings.tokenWarning": "Token sẽ không hiện lại.",
  "settings.revoke": "Thu hồi",
  "settings.revokeConfirm": "Thu hồi mật khẩu ứng dụng này?",
  "settings.lastUsed": "Dùng lần cuối {when}",
  "settings.expiresOn": "Hết hạn {when}",
  "settings.never": "Không",
  "settings.noAppPasswords": "Chưa có mật khẩu ứng dụng.",
  "settings.languageHint": "Đổi ngôn ngữ ứng dụng. Mỗi CV có ngôn ngữ riêng.",
  "settings.exportData": "Xuất dữ liệu của tôi",
  "settings.deleteAccount": "Xoá tài khoản",
  "settings.dangerBody": "Thao tác này xoá CV, hình ảnh và gói đăng ký của bạn.",
  "settings.deleteConfirm": "Nhập DELETE để xác nhận",
  "settings.appPasswordLimit": "Bạn có thể giữ mười mật khẩu ứng dụng.",
  "settings.saved": "Đã lưu",
  "settings.changePassword": "Đổi mật khẩu",
  "settings.currentPassword": "Mật khẩu hiện tại",
  "settings.newPassword": "Mật khẩu mới",
  "settings.signOutEverywhere": "Đăng xuất trên mọi thiết bị",
  "settings.passwordChanged": "Đã cập nhật mật khẩu.",
  "settings.wrongPassword": "Mật khẩu hiện tại không đúng.",
  "settings.sessionsRevoked": "Đã đăng xuất trên các thiết bị khác.",
  "settings.scopeRead": "Đọc CV",
  "settings.scopeWrite": "Sửa CV",
  "settings.scopePublish": "Xuất bản CV",
  "settings.scopeAssets": "Tải ảnh lên",

  "billing.title": "Thanh toán",
  "billing.currentPlan": "Gói hiện tại",
  "billing.status": "Trạng thái",
  "billing.proTitle": "YourCV Pro",
  "billing.proBody": "Nhiều chỗ hơn, mọi mẫu, không huy hiệu.",
  "billing.manage": "Quản lý đăng ký",
  "billing.checkoutSuccess": "Bạn đã có Pro. Có thể mất một lúc để cập nhật.",
  "billing.checkoutCancelled": "Đã huỷ thanh toán.",
  "billing.alreadyPro": "Bạn đã có Pro.",
  "billing.subscribe": "Nâng cấp lên Pro",
  "billing.portalUnavailable": "Thanh toán chưa được cấu hình.",
  "billing.perMonth": "mỗi tháng",
  "billing.perYear": "mỗi năm",
  "billing.freePlan": "Miễn phí",
  "billing.renews": "Gia hạn {date}",
  "billing.ends": "Kết thúc {date}",
  "billing.monthlyPrice": "$8",
  "billing.yearlyPrice": "$76",
  "billing.freeBody": "Hai CV và năm mẫu.",
  "billing.teamTitle": "YourCV Team",
  "billing.teamBody": "Pro cho một nhóm người. Một gói, một hoá đơn.",
  "billing.teamCta": "Thiết lập nhóm",
  "billing.viaOrganization": "Quyền Pro của bạn đến từ một tổ chức.",

  "organization.title": "Tổ chức",
  "organization.subtitle": "Trả tiền theo chỗ. Mọi thành viên có Pro khi gói nhóm còn hiệu lực.",
  "organization.create": "Tạo tổ chức",
  "organization.createTitle": "Tạo tổ chức",
  "organization.name": "Tên tổ chức",
  "organization.namePlaceholder": "Acme Tuyển dụng",
  "organization.emptyTitle": "Chưa có tổ chức.",
  "organization.emptyBody": "Tạo một tổ chức, chọn số chỗ và mời nhóm của bạn.",
  "organization.members": "{count} thành viên",
  "organization.memberCount": "Thành viên",
  "organization.seatCount": "Số chỗ",
  "organization.pendingInvites": "Lời mời chờ",
  "organization.role.owner": "Chủ sở hữu",
  "organization.role.admin": "Quản trị",
  "organization.role.member": "Thành viên",
  "organization.planActive": "Gói nhóm đang hoạt động",
  "organization.planInactive": "Chưa có gói",
  "organization.open": "Quản lý",
  "organization.invite": "Mời thành viên",
  "organization.inviteTitle": "Mời thành viên",
  "organization.inviteEmail": "Email",
  "organization.emailPlaceholder": "ten@congty.com",
  "organization.inviteRole": "Vai trò",
  "organization.inviteSent": "Đã tạo lời mời.",
  "organization.inviteLink": "Liên kết mời",
  "organization.invitePending": "Đang chờ",
  "organization.inviteAccepted": "Đã chấp nhận",
  "organization.inviteExpired": "Đã hết hạn",
  "organization.revokeInvite": "Thu hồi",
  "organization.revokeInviteConfirm": "Thu hồi lời mời này?",
  "organization.copyLink": "Sao chép liên kết",
  "organization.copied": "Đã sao chép liên kết",
  "organization.membersTitle": "Thành viên",
  "organization.invitationsTitle": "Lời mời",
  "organization.billingTitle": "Thanh toán nhóm",
  "organization.billingBody": "Một gói trả cho mọi chỗ. Thành viên có Pro khi gói còn hiệu lực.",
  "organization.seats": "Số chỗ",
  "organization.seatsHint": "Số chỗ gồm thành viên và lời mời đang chờ.",
  "organization.subscribeTeam": "Đăng ký {seats} chỗ",
  "organization.perSeat": "mỗi chỗ",
  "organization.manageBilling": "Quản lý thanh toán nhóm",
  "organization.renews": "Gia hạn {date}",
  "organization.ends": "Kết thúc {date}",
  "organization.subscriptionRequired": "Đăng ký gói để mời thành viên.",
  "organization.upgradeTitle": "Trả tiền cho người, không phải phần mềm.",
  "organization.upgradeBody":
    "Gói nhóm trả cho một cụm chỗ. Thêm hoặc bớt người khi nhóm thay đổi.",
  "organization.upgradeCta": "Thiết lập nhóm",
  "organization.leave": "Rời tổ chức",
  "organization.leaveConfirm": "Rời tổ chức này? CV của bạn vẫn thuộc về bạn.",
  "organization.delete": "Xoá tổ chức",
  "organization.deleteConfirm": "Xoá tổ chức này và huỷ gói đăng ký?",
  "organization.deleteBody":
    "Thao tác này xoá thành viên và lời mời đang chờ. CV của thành viên vẫn ở tài khoản của họ.",
  "organization.rename": "Đổi tên",
  "organization.saved": "Đã lưu",
  "organization.roleChanged": "Đã cập nhật vai trò",
  "organization.memberRemoved": "Đã xoá thành viên",
  "organization.lastOwner": "Thêm một chủ sở hữu khác trước khi rời.",
  "organization.acceptTitle": "Tham gia {name}",
  "organization.acceptBody": "{email} được mời với vai trò {role}.",
  "organization.accept": "Chấp nhận lời mời",
  "organization.accepted": "Bạn đã tham gia tổ chức.",
  "organization.inviteNotFound": "Lời mời không hợp lệ hoặc đã hết hạn.",
  "organization.signInToAccept": "Đăng nhập để chấp nhận.",
  "organization.backToOrgs": "Về danh sách tổ chức",
  "organization.noSeats": "Không còn chỗ. Tăng gói hoặc thu hồi lời mời đang chờ.",
  "organization.checkoutSuccess": "Đã bắt đầu gói nhóm. Có thể mất một lúc để cập nhật.",
  "organization.checkoutCancelled": "Đã huỷ thanh toán nhóm.",
  "organization.portalUnavailable": "Thanh toán chưa được cấu hình trên bản triển khai này.",
  "organization.you": "Bạn",
  "organization.removeMember": "Xoá",
  "organization.removeConfirm": "Xoá thành viên này? CV vẫn ở tài khoản của họ.",
  "organization.changeRole": "Vai trò",
  "organization.teamPlan": "YourCV Team",
  "organization.teamBody": "Pro cho mọi chỗ. Một hoá đơn cho cả nhóm.",
  "organization.teamFeature1": "Giới hạn Pro cho mọi thành viên",
  "organization.teamFeature2": "Mọi mẫu, không huy hiệu",
  "organization.teamFeature3": "Mời và xoá thành viên",
  "organization.teamFeature4": "Một hoá đơn cho cả nhóm",
  "organization.manage": "Quản lý tổ chức",
  "organization.status": "Trạng thái",
  "organization.ownerOnly": "Chỉ chủ sở hữu mới làm được.",
  "organization.ownerLeave": "Chuyển quyền sở hữu trước khi rời.",
  "organization.onlyOwnerDelete": "Chỉ chủ sở hữu mới xoá được tổ chức.",
  "organization.tooManySeats": "Chọn từ 1 đến 500 chỗ.",
  "organization.seatsBelowMembers": "Số chỗ không thể ít hơn số thành viên hiện tại.",
  "organization.alreadySubscribed": "Nhóm đã có gói. Dùng trang thanh toán để đổi số chỗ.",
  "organization.teamPrice": "$8",
  "organization.perMonth": "mỗi chỗ / tháng",
  "organization.perYear": "mỗi chỗ / năm",
  "organization.yearlyPrice": "$76",
  "organization.seatUsage": "Đã dùng {used}/{seats} chỗ",
  "organization.noPendingInvites": "Không có lời mời đang chờ.",
  "organization.inviteExpires": "Hết hạn {date}",
  "organization.roleHint":
    "Chủ sở hữu quản lý thanh toán và vai trò. Quản trị viên quản lý thành viên và lời mời.",
  "organization.settingsTitle": "Cài đặt tổ chức",
  "organization.manageSeats": "Đổi số chỗ trong cổng thanh toán.",
  "organization.wrongAccount": "Đang đăng nhập là {current}. Lời mời dành cho {email}.",
  "organization.switchAccount": "Dùng tài khoản khác",

  "public.madeWith": "Tạo bằng YourCV",
  "public.openFull": "Mở CV đầy đủ",
  "public.print": "In",
  "public.notFound": "CV này riêng tư hoặc không tồn tại.",

  "cv.present": "Hiện tại",
  "cv.summary": "Giới thiệu",
  "cv.experience": "Kinh nghiệm",
  "cv.education": "Học vấn",
  "cv.projects": "Dự án",
  "cv.skills": "Kỹ năng",
  "cv.languages": "Ngôn ngữ",
  "cv.certifications": "Chứng chỉ",
  "cv.awards": "Giải thưởng",
  "cv.links": "Liên kết",
  "cv.contact": "Liên hệ",
  "cv.email": "Email",
  "cv.phone": "Điện thoại",
  "cv.location": "Địa điểm",

  "legal.privacy": "Quyền riêng tư",
  "legal.terms": "Điều khoản",
  "legal.lastUpdated": "Cập nhật tháng 10 năm 2026",
  "legal.privacyBody":
    "Chúng tôi lưu nội dung CV bạn nhập, hình ảnh bạn tải lên và email tài khoản. Chúng tôi dùng Stripe để thanh toán và không lưu thông tin thẻ. Bạn có thể xuất hoặc xoá dữ liệu trong Cài đặt bất cứ lúc nào.",
  "legal.refunds": "Hoàn tiền",
  "legal.refundsBody":
    "Bạn có thể huỷ gói Pro bất cứ lúc nào trong cổng thanh toán. Liên hệ với chúng tôi trong 14 ngày kể từ khi bị tính phí để được hoàn tiền.",
  "legal.termsBody":
    "YourCV được cung cấp nguyên trạng. Bạn sở hữu nội dung mình tạo. Không tải lên nội dung trái pháp luật. Gói Pro tự gia hạn cho đến khi huỷ trong cổng thanh toán.",

  "errors.generic": "Đã có lỗi. Thử lại.",
  "errors.unauthorized": "Vui lòng đăng nhập.",
  "errors.notFound": "Không tìm thấy.",
  "errors.proRequired": "Mẫu này có trong gói Pro.",
  "errors.resumeLimit": "Bạn đã đạt giới hạn CV.",
  "errors.storageLimit": "Bạn đã đạt giới hạn dung lượng.",
  "errors.appPasswordLimit": "Bạn có thể giữ mười mật khẩu ứng dụng.",
  "errors.validation": "Kiểm tra các trường được đánh dấu.",
  "errors.network": "Lỗi mạng. Kiểm tra kết nối.",
  "errors.slugTaken": "Liên kết này đã được dùng.",
  "errors.fileType": "Dùng ảnh JPEG, PNG, WebP hoặc AVIF.",
  "errors.fileSize": "Ảnh phải nhỏ hơn 5 MB.",
  "errors.stripe": "Thanh toán hiện không khả dụng.",
  "errors.forbidden": "Bạn không có quyền truy cập.",
  "errors.orgSubscription": "Đăng ký gói nhóm trước khi mời thành viên.",
  "errors.orgSeatLimit": "Không còn chỗ trống.",
  "errors.lastOwner": "Tổ chức cần ít nhất một chủ sở hữu.",
  "errors.orgOwner": "Chuyển giao hoặc xóa tổ chức trước khi xóa tài khoản.",
  "errors.alreadyMember": "Người này đã là thành viên.",
  "errors.alreadyInvited": "Người này đã có lời mời đang chờ.",
  "errors.inviteUsed": "Lời mời này đã được dùng.",
  "errors.inviteExpired": "Lời mời này đã hết hạn.",

  "locale.en": "English",
  "locale.vi": "Tiếng Việt",
} satisfies Messages;
